var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useEffect, useState } from 'react';
export const usePrevNextButtons = (emblaApi) => {
    const [prevBtnDisabled, setPrevBtnDisabled] = useState(true);
    const [nextBtnDisabled, setNextBtnDisabled] = useState(true);
    const onPrevButtonClick = useCallback(() => {
        if (!emblaApi)
            return;
        emblaApi.scrollPrev();
    }, [emblaApi]);
    const onNextButtonClick = useCallback(() => {
        if (!emblaApi)
            return;
        emblaApi.scrollNext();
    }, [emblaApi]);
    const onSelect = useCallback((emblaApi) => {
        setPrevBtnDisabled(!emblaApi.canScrollPrev());
        setNextBtnDisabled(!emblaApi.canScrollNext());
    }, []);
    useEffect(() => {
        if (!emblaApi)
            return;
        onSelect(emblaApi);
        emblaApi.on('reInit', onSelect).on('select', onSelect);
    }, [emblaApi, onSelect]);
    return {
        prevBtnDisabled,
        nextBtnDisabled,
        onPrevButtonClick,
        onNextButtonClick,
    };
};
export const PrevButton = (props) => {
    const { children } = props, restProps = __rest(props, ["children"]);
    return (React.createElement("button", Object.assign({ className: "embla__button embla__button--prev", type: "button", "aria-label": "Previous Slide" }, restProps),
        React.createElement("svg", { width: "8", height: "14", viewBox: "0 0 8 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M6.83203 13L0.832032 7L6.83203 1", stroke: "#121212", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })),
        children));
};
export const NextButton = (props) => {
    const { children } = props, restProps = __rest(props, ["children"]);
    return (React.createElement("button", Object.assign({ className: "embla__button embla__button--next", type: "button", "aria-label": "Next Slide" }, restProps),
        React.createElement("svg", { width: "8", height: "14", viewBox: "0 0 8 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M1.16797 1L7.16797 7L1.16797 13", stroke: "#121212", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })),
        children));
};
